export default "__VITE_ASSET__BNmXuOrm__"